var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.comments.length)?_vm._l((_vm.comments),function(item,index){return _c('CommentBlock',{key:`${_vm.parentId}-${index}`,attrs:{"comment":item,"show-replies":false}})}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }